import {
  INSERT_ITEM,
  DELETE_ITEM,
  FILTERS_SET,
  USER_LIST_SET,
  USER_ROLE_LIST_SET,
  REGISTRAR_LIST_SET,
  LANGS_SET,
  LINK_ORDER_SET,
  ORDERS_SET,
  HOSTS_SET,
  MAINTENANCE_ORDERS_SET, PPC_DATA_SET, PBN_SET, BOOKMARKS_SET,
  PROJECT_TASKS_SET, PROJECTS_SET, DATA_SET, BRANDS_SET
} from './mutation-types.js'
import axios from 'axios'

export const isAuthenticated = (state, data) => {
  state.isAuthenticated = data
}

export const saved = (state, data) => {
  state.players.openPlayers = data
}

export const viewData = (state, data) => {
  state.viewData = data
}

export const playerData = (state, data) => {
  state.playerData = data
}

export const playerStats = (state, data) => {
  state.playerStats = data
}

export const playerLogs = (state, data) => {
  state.playerLogs = data
}

export const playerGamePlayStats = (state, data) => {
  state.playerGamePlayStats = data
}

export const playerActivity = (state, data) => {
  state.playerActivity = data
}

export const playerDocuments = (state, data) => {
  state.playerDocuments = data
}

export const playerLog = (state, data) => {
  state.playerLog = data
}

export const playerActiveBonuses = (state, data) => {
  state.playerActiveBonuses = data
}

export const inserItem = ({ commit }, draggable) => {
  commit(INSERT_ITEM, draggable)
}

export const delItem = ({ commit }, index) => {
  commit(DELETE_ITEM, index)
}

export const loadUsers = ({ commit }, query = '') => {
  axios.get(`/users?${query}`).then(r => {
    commit(USER_LIST_SET, r.data)
  }).catch(e => {
    throw e
  })
}

export const loadUserRoles = ({ commit }) => {
  axios.get('/roles').then(r => {
    commit(USER_ROLE_LIST_SET, r.data)
  }).catch(e => {
    throw e
  })
}

export const loadLanguages = ({ commit }) => {
  axios.get('/am/langs?type=array').then(r => {
    commit(LANGS_SET, r.data)
  }).catch(e => {
    throw e
  })
}

export const loadBuildOrders = ({ commit }) => {
  axios.get('/pbn/builds/orders').then(r => {
    commit(ORDERS_SET, r.data.data)
  }).catch(e => {
    throw e
  })
}

export const loadLinkOrder = async ({ commit }, id, filters = '') => {
  axios.get(`/pbn/links/order/${id}?${filters}`)
    .then(r => {
      commit(LINK_ORDER_SET, r.data)
    })
    .catch(e => {
      throw e
    })
}

export const loadRegistrars = ({ commit }, query = '') => {
  axios.get(`/registrars?${query}`).then(r => {
    commit(REGISTRAR_LIST_SET, r.data.data)
  }).catch(e => {
    throw e
  })
}

export const loadHosts = ({ commit }, query = '') => {
  axios.get(`/hosts?${query}`).then(r => {
    commit(HOSTS_SET, r.data.data)
  }).catch(e => {
    throw e
  })
}

export const loadMaintenanceOrders = ({ commit }, query = '') => {
  axios.get(`/maintenance/orders?${query}`)
    .then(r => {
      commit(MAINTENANCE_ORDERS_SET, r.data.data)
    })
}

export const loadPpcData = async ({ commit }, query = '') => {
  let data = await axios.get(`/ppc/data?${query}`)
  commit(PPC_DATA_SET, data.data)
}

export const loadPpcAccount = ({ commit }, id) => {
  axios.get(`/ppc/accounts/${id}`)
    .then(r => {
      return r.data
    })
}

export const loadFilters = ({ commit }) => {
  axios.get('/pbn/filters').then(r => {
    commit(FILTERS_SET, r.data)
  }).catch(e => {
    throw e
  })
}

export const loadBrands = ({ commit }, query = '') => {
  axios.get(`/advertisers/brands?${query}`).then(r => {
    commit(BRANDS_SET, r.data)
  }).catch(e => {
    throw e
  })
}

export const postUserFilter = async ({ commit }, data) => {
  return axios.post(`/user/filters`, data)
}

export const patchUserFilter = async ({commit}, data) => {
  await axios.patch(`/user/filters/${data.id}`, {filters: data.filters, name: data.name})
}

export const deleteUserFilter = async ({commit}, data) => {
  await axios.delete(`/user/filters/${data.id}`)
}

export const setCustomData = async ({ commit }, data) => {
  let pbn = await axios.patch(`/pbn/site/${data.domain}`, {
    customData: data.data
  })
  commit(PBN_SET, pbn.data.pbn)
  return pbn
}

export const SOCKETupdatePbn = ({ commit }, msg) => {
  console.log('got a test msg! ', msg)
}

export const fetchBookmarks = async ({ commit }, data) => {
  const bookmarks = await axios.get(`/v2/user/bookmarks`)
  commit(BOOKMARKS_SET, bookmarks.data)
}

export const createBookmark = async ({ commit }, data) => {
  await axios.post('/v2/user/bookmarks', data)
}

export const editBookmark = async ({ commit }, data) => {
  await axios.patch(`/v2/user/bookmarks/${data.id}`, data)
}

export const deleteBookmark = async ({ commit }, id) => {
  await axios.delete(`/v2/user/bookmarks/${id}`)
}

export const fetchData = async ({ commit }, name) => {
  return axios.get(`/v2/data-structures/${name}`)
}

export const fetchMultipleData = async ({ commit }, names) => {
  let dataList = (await axios.get(`/v2/data-structures?name=${names}`)).data
  for (const el of dataList) {
    commit(DATA_SET, el)
  }
}

export const fetchXeroAccounts = async ({ commit }) => {
  let accounts = await axios.get(`/integrations/xero/accounts`)
  commit('setXeroAccounts', accounts.data)
}
export const fetchXeroItems = async ({ commit }) => {
  let items = await axios.get(`/integrations/xero/items`)
  commit('setXeroItems', items.data)
}
export const fetchXeroContacts = async ({ commit }) => {
  let contacts = await axios.get(`/integrations/xero/contacts`)
  commit('setXeroContacts', contacts.data)
}

export const fetchXeroCategories = async ({ commit }) => {
  let categories = await axios.get(`/integrations/xero/categories`)
  commit('setXeroCategories', categories.data)
}

export const fetchProjects = async ({ commit }, query = '') => {
  const r = await axios.get(`/v2/projects?${query}`)
  commit(PROJECTS_SET, r.data)
}

export const fetchProjectTasks = async ({ commit }, query = '') => {
  const r = await axios.get(`/v2/tasks?${query}`)
  commit(PROJECT_TASKS_SET, r.data)
}

export const fetchPbnTypes = async ({ commit }) => {
  let types = (await axios.get(`/v2/data-structures/site-types`)).data.values
  commit('setPbnTypes', types)
}



// WEBPACK FOOTER //
// ./src/store/actions.js